import { INGESTION_POLICIES } from 'modules/customEvents/types';
import { createContext, useContext } from 'react';
import { ALL_TIME } from 'ui/datePicker/helpers';
import noop from 'utils/noop';
import { CONTENT_SECTIONS } from '../constants';
import { SearchParamsContextState } from '../types';

export const initialSearchParamsState: SearchParamsContextState = {
  contentSection: CONTENT_SECTIONS.customEvents,
  debouncedSearch: '',
  endDate: '',
  ingestionPolicy: INGESTION_POLICIES.SAVED,
  journeyTriggers: [],
  preset: ALL_TIME,
  resetSearchParams: noop,
  search: '',
  setContentSection: noop,
  setEndDate: noop,
  setIngestionPolicy: noop,
  setJourneyTriggers: noop,
  setPreset: noop,
  setSearch: noop,
  setStartDate: noop,
  setVisibility: noop,
  startDate: '',
  visibility: [],
};

export const SearchParamsContext = createContext(initialSearchParamsState);

export const useSearchParamsContext = () => useContext(SearchParamsContext);
